export const getBundlerVersion = () => window.BUNDLER_VERSION;
